import React from 'react';

function TitleBar() {
   const handleMinimize = () => {
      if (window.electronAPI) {
         window.electronAPI.minimize();
      }
   };

   const handleMaximize = () => {
      if (window.electronAPI) {
         window.electronAPI.maximize();
      }
   };

   const handleClose = () => {
      if (window.electronAPI) {
         window.electronAPI.close();
      }
   };

   /* Window Controls (for Windows/Linux) */
   return (
      window.electronAPI &&
      window.electronAPI.platform !== 'darwin' && (
         <div className="draggable h-10 bg-ink border-b border-charcoal flex items-center justify-end px-4">
            <div className="flex items-center space-x-1">
               <button
                  onClick={handleMinimize}
                  className="no-drag w-8 h-8 flex items-center justify-center hover:bg-charcoal rounded transition-colors"
               >
                  <svg className="w-3 h-3 text-silver" fill="currentColor" viewBox="0 0 24 24">
                     <rect x="4" y="11" width="16" height="2" />
                  </svg>
               </button>
               <button
                  onClick={handleMaximize}
                  className="no-drag w-8 h-8 flex items-center justify-center hover:bg-charcoal rounded transition-colors"
               >
                  <svg
                     className="w-3 h-3 text-silver"
                     fill="none"
                     stroke="currentColor"
                     strokeWidth="2"
                     viewBox="0 0 24 24"
                  >
                     <rect x="4" y="4" width="16" height="16" />
                  </svg>
               </button>
               <button
                  onClick={handleClose}
                  className="no-drag w-8 h-8 flex items-center justify-center hover:bg-blood rounded transition-colors"
               >
                  <svg className="w-3 h-3 text-silver" fill="currentColor" viewBox="0 0 24 24">
                     <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
               </button>
            </div>
         </div>
      )
   );
}

export default TitleBar;
